Kubrick.Process = {
  // Status tracker
  STATUS: Kubrick.STATUS.READY,

  // Selectors
  _selector_slider: ".block.process.slider",
  _step_selector: ".processstep",
  _step_wrapper: ".wrapper",
  _position_selector: ".control-counter .location",
  _controls_selector: ".controls",
  _control_previous_selector: "button.previous",
  _control_next_selector: "button.next",
  _selector_concentric: ".block.process.concentric",
  _selector_concentric_overlay: ".processstep-overlay",

  //
  _controllers: [],
  _configs: [],

  //////
  /////
  // Slider
  /////
  /////
  startSlider: function(config) {
    Kubrick._log("Process: Configuring [slider]...", config);
    let $ITEM = document.querySelector("#content ." + config.id);
    if ($ITEM) {
      this._setupSliderBlock($ITEM);
      this._configs.push(config);
    } else {
      Kubrick._log("Process: Failed [slider] ", config.id);
    }
  },

  _setupSliderBlock: function($ITEM) {
    var controller = {
      $PARENT: $ITEM,
      $WRAPPER: $ITEM.querySelector(this._step_wrapper),
      $STEPS: [].slice.call($ITEM.querySelectorAll(this._step_selector)),
      $CONTROLS: $ITEM.querySelector(this._controls_selector),
      $PREVIOUS: $ITEM.querySelector(this._control_previous_selector),
      $POSITION: $ITEM.querySelector(this._position_selector),
      $NEXT: $ITEM.querySelector(this._control_next_selector),
      STATUS: Kubrick.STATUS.READY,
      POSITION: 1
    };
    controller.$NEXT.addEventListener("click", this._nextStep.bind(controller));
    controller.$PREVIOUS.addEventListener(
      "click",
      this._previousStep.bind(controller)
    );
    this._controllers.push(controller);
  },

  _updatePosition: function(positionDOM, positionValue) {
    positionDOM.textContent = positionValue;
  },

  _nextStep: function(e) {
    // Scope is .stepprocess
    if (
      this.STATUS == Kubrick.STATUS.READY &&
      this.POSITION < this.$STEPS.length
    ) {
      var obj = this;
      let step = this.$STEPS[this.POSITION];
      let w = step.offsetWidth;

      this.$MOVED_STEPS = this.$STEPS.slice(0, this.POSITION);
      Kubrick.Process._updatePosition(this.$POSITION, ++this.POSITION);
      this.STATUS = Kubrick.STATUS.RUNNING;

      anime({
        targets: this.$STEPS,
        // translateX: "-=" + w,
        translateX: "-=100%",
        delay: anime.stagger(120),
        easing: Kubrick.EASING.NORMAL,
        duration: 800,
        complete: function() {
          obj.STATUS = Kubrick.STATUS.READY;
        }
      });

      anime({
        targets: this.$MOVED_STEPS,
        opacity: 0.5,
        easing: Kubrick.EASING.NORMAL,
        duration: 500
      });
    }
  },

  _previousStep: function(e) {
    // Scope is .stepprocess
    if (this.STATUS == Kubrick.STATUS.READY && this.POSITION > 1) {
      var obj = this;
      var step = this.$STEPS[this.POSITION - 1];
      var w = step.offsetWidth;
      Kubrick.Process._updatePosition(this.$POSITION, --this.POSITION);
      this.STATUS = Kubrick.STATUS.RUNNING;

      anime({
        targets: this.$STEPS.slice().reverse(),
        // translateX: "+=" + w,
        translateX: "+=100%",
        delay: anime.stagger(120),
        easing: Kubrick.EASING.NORMAL,
        duration: 800,
        complete: function() {
          obj.STATUS = Kubrick.STATUS.READY;
        }
      });

      anime({
        targets: this.$MOVED_STEPS.pop(),
        opacity: 1,
        easing: Kubrick.EASING.NORMAL,
        delay: 300,
        duration: 500
      });
    }
  },

  //////
  /////
  // Concentric
  /////
  /////
  startConcentric: function(config) {
    Kubrick._log("Process: Configuring [concentric]...", config);
    let $ITEM = document.querySelector("#content ." + config.id);
    if ($ITEM) {
      this._setupConcentricBlock($ITEM);
      this._configs.push(config);
    } else {
      Kubrick._log("Process: Failed [concentric] ", config.id);
    }
  },

  _setupConcentricBlock: function($BLOCK) {
    let $STEPS = $BLOCK.querySelectorAll(this._step_selector);
    for (let i = 0; i < $STEPS.length; i++) {
      let $STEP = $STEPS[i];
      $STEP.addEventListener("click", this._openConcentricStep.bind(this));
    }
  },

  _openConcentricStep: function(e) {
    let $PARENT = e.target.closest(".block.process");
    let $STEP = e.target.closest(".processstep");
    let $OVERLAY = $PARENT.querySelector($STEP.getAttribute("data-target"));
    if ($OVERLAY) {
      let $CLOSE = $OVERLAY.querySelector("button.close");
      $OVERLAY.classList.add("open");

      anime({
        targets: $OVERLAY,
        opacity: [0, 1],
        easing: Kubrick.EASING.NORMAL,
        duration: 1000
      });

      $CLOSE.addEventListener("click", function(e) {
        anime({
          targets: $OVERLAY,
          opacity: [1, 0],
          easing: Kubrick.EASING.NORMAL,
          duration: 1000,
          complete: function() {
            $OVERLAY.classList.remove("open");
          }
        });
      });
    }

    Kubrick._log("Process: Opening step...", e);
  }
};
